module.exports = __webpack_public_path__ + "static/terminal--red_moon.9efb0e1e1ed9770f4ee3a27aec35aaaf.jpg";